import { Grid } from 'components/shared/Grid';
import { ContentType } from 'constants/types';
import React from 'react';
import { connect } from 'react-redux';
import accountRowsSelector from 'selectors/accountRows';
import { periodColumnsSelector } from 'selectors/periods';

class AccountsFilterableGridBase extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
    };

    this.cols = [
      {
        headerName: 'Number',
        field: 'number',
      },
      {
        headerName: 'Description',
        field: 'description',
      },
      {
        headerName: 'Group',
        field: 'group',
      },
      ...props.periodColumns,
    ];
  }

  handleSearchChange = ({ target }) =>
    this.setState({ searchText: target.value });

  handleCellDoubleClicked = ({ data }) => {
    const id = parseInt(data.id, 10);
    this.props.onSelect(ContentType.account, id, data.description);
  };

  getContextMenuItems = ({ node }) => {
    if (!node) {
      return [];
    }
    const id = parseInt(node.data.id, 10);
    return [
      {
        name: 'Select Account',
        action: () =>
          this.props.onSelect(ContentType.account, id, node.data.description),
      },
    ];
  };

  render() {
    return (
      <div className="accounts-filterable-grid">
        <input
          type="text"
          autoComplete="off"
          placeholder="Search"
          onChange={this.handleSearchChange}
        />
        <Grid
          columnDefs={this.cols}
          rowData={this.props.rows}
          onCellDoubleClicked={this.handleCellDoubleClicked}
          getContextMenuItems={this.getContextMenuItems}
          quickFilterText={this.state.searchText}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rows: accountRowsSelector(state),
    periodColumns: periodColumnsSelector(state, {
      useGroupsPrecision: true,
      hasMostImportantCols: true,
      hasMostImportantPeriods: true,
    }),
  };
}

export const AccountsFilterableGrid = connect(mapStateToProps)(
  AccountsFilterableGridBase
);
